// PAGES
import processes_page from './processes/processes.js';

export default [
	processes_page,
];
